import { useEffect, useState } from 'react';
import { useFlipperExperimentBucketQueryLazyQuery, useMembershipQuery } from '../../generated/graphql';

export const CONTROL_VARIANT = 'control';
export const VARIANT = 'variant';

type RegistryGuidanceVariant = 'control' | 'variant';

export const useWWSRegistryGuidanceModule = () => {
  const [variant, setVariant] = useState<RegistryGuidanceVariant>(CONTROL_VARIANT);

  const { data: memberData, loading: memberLoading } = useMembershipQuery();
  const [callFlipperAssignment, { data: variantData, loading }] = useFlipperExperimentBucketQueryLazyQuery();

  useEffect(() => {
    if (memberLoading || !memberData?.member?.id || memberData?.member?.id === '') return;

    callFlipperAssignment({
      variables: {
        flipperExperimentBucketExperimentId: process.env
          .REACT_APP_FLIPPER_WWS_REGISTRY_GUIDANCE_MODULE_EXP_ID as string,
        flipperExperimentBucketId: memberData.member.id,
      },
    });
  }, [memberLoading, memberData, callFlipperAssignment]);

  useEffect(() => {
    setVariant(
      prevVariant => (variantData?.flipperExperimentBucket?.variant_name as RegistryGuidanceVariant) || prevVariant
    );
  }, [variantData]);

  return { variant, loading };
};
